/**
 * Extract domain from a URL string (e.g., "https://www.example.com/path" → "example.com")
 */
export const extractDomain = (url?: string | null): string | undefined => {
	if (!url) {
		return undefined;
	}

	try {
		const hostname = new URL(url.startsWith("http") ? url : `https://${url}`).hostname;

		return hostname.replace(/^www\./, "") || undefined;
	} catch {
		return undefined;
	}
};
